import { render, staticRenderFns } from "./TributeEvent.vue?vue&type=template&id=9ea1a1dc"
import script from "./TributeEvent.vue?vue&type=script&lang=js"
export * from "./TributeEvent.vue?vue&type=script&lang=js"
import style0 from "./TributeEvent.vue?vue&type=style&index=0&id=9ea1a1dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports